import { Fragment } from 'react';
import type { ConversationSummary } from '@dermalink/shared';
import { ConversationCard } from '../ConversationCard.tsx';
import { conversationDisplayName } from '../conversationLabels.ts';
import styles from './ConversationList.module.css';

interface ConversationListProps {
  conversations: ConversationSummary[];
  selectedConversationId: number | null;
  onSelect: (id: number) => void;
  /** Index in `conversations` before which a section divider is inserted, e.g. to separate not-yet-downloaded closed consults from already-downloaded ones. */
  splitIndex?: number;
  splitLabel?: string;
}

export function ConversationList({
  conversations,
  selectedConversationId,
  onSelect,
  splitIndex,
  splitLabel,
}: ConversationListProps) {
  return (
    <>
      {conversations.map((conv, i) => (
        <Fragment key={conv.id}>
          {i === splitIndex && (
            <div className={styles.splitter}>
              <div className={styles.splitterLine} />
              <span className={styles.splitterLabel}>{splitLabel}</span>
              <div className={styles.splitterLine} />
            </div>
          )}
          <ConversationCard
            conv={conv}
            displayName={conversationDisplayName(conv)}
            selected={selectedConversationId === conv.id}
            onClick={() => onSelect(conv.id)}
          />
        </Fragment>
      ))}
    </>
  );
}
